import { Lock } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';

interface PremiumBadgeProps {
  unlocked: boolean;
}

/**
 * "PRO" lock chip shown on premium-gated controls (Edit tab, Download,
 * Letterhead) while the document is locked for an unpaid guest. Authenticated
 * org users and paid guests pass `unlocked` and the badge renders nothing.
 */
export function PremiumBadge({ unlocked }: PremiumBadgeProps) {
  return (
    <AnimatePresence>
      {!unlocked && (
        <motion.span
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: 0.2 }}
          className="inline-flex items-center gap-0.5 ml-1 px-1.5 py-0.5 rounded bg-selise-blue/15 text-selise-blue"
          title="Premium feature — $5.00 one-time"
        >
          <Lock className="w-3 h-3" />
          <span className="text-[11px] font-semibold tracking-wide">PRO</span>
        </motion.span>
      )}
    </AnimatePresence>
  );
}
